import React, { useEffect, useRef, useState } from "react";
import ErrorAlert from "../components/ErrorAlert";
import SuccessAlert from "../components/SuccessAlert";

export default function Profile() {
  const showHide = useRef(null);

  const showHandler = () => {
    showHide.current.type = "text";
  };

  const HideHandler = () => {
    showHide.current.type = "password";
  };

  // State Handling
  const [usersData, setUsersData] = useState({
    user_img: "",
    user_first_name: "",
    user_last_name: "",
    user_email: "",
    user_password: "",
    user_home_address: "",
    user_phone_number: "",
  });

  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [updateLoading, setUpdateLoading] = useState(false);

  // Upload Image Handling
  const userImgHandler = (e) => {
    const imgFile = e.target.files[0];
    if (imgFile) {
      const imgReader = new FileReader();
      imgReader.readAsDataURL(imgFile);
      imgReader.onloadend = () => {
        setUsersData({
          ...usersData,
          user_img: imgReader.result,
        });
      };
      imgReader.onerror = (error) => {
        console.log(error);
      };
    }
  };

  //   Get User's Data
  const adminUserData = async () => {
    const response = await fetch(
      `https://hotelbnb-backend.onrender.com/user/ascodesofficial@gmail.com`
    );
    const result = await response.json();

    if (response.ok) {
      setUsersData(result);
    }
  };

  useEffect(() => {
    adminUserData();
  }, []);

  // Form Submission To Update Admin In DataBase
  const updateUsersHandler = async (e) => {
    window.scrollTo(0, 0);
    setUpdateLoading(true);

    try {
      const response = await fetch(
        `https://hotelbnb-backend.onrender.com/edit-user/ascodesofficial@gmail.com`,
        {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(usersData),
        }
      );
      const result = await response.json();

      if (response.ok) {
        setError("");
        setSuccess("Profile Updated!");
      } else if (!response.ok) {
        setSuccess("");
        setError("Update Failed! Please Try Again");
      }
    } catch (error) {
      console.log(error);
    } finally {
      setUpdateLoading(false);
    }
  };

  if (updateLoading)
    return (
      <div className="d-flex flex-column gap-2 justify-content-center align-items-center loading-state">
        <div className="spinner-grow" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
        <p>Updating Profile</p>
      </div>
    );

  if (!updateLoading)
    return (
      <>
        {/* Showing Alert based on http request response Start */}
        {success && <SuccessAlert successMsg={success} />}
        {error && <ErrorAlert errorMsg={error} />}
        {/* Showing Alert based on http request response End */}

        {/* Admin Profile Header Start */}
        <div className="container-fluid p-0 user-panel-header admin-panel-profile-header">
          <div className="row app-container justify-content-center align-items-center">
            {/* Details Side */}
            <div className="col-6 details-side">
              <h1 className="fw-bold text-capitalize">
                Welcome {usersData.user_first_name}
              </h1>
              <div className="account-email">
                <p className="m-0 mb-1 account-email-title">Account Email</p>
                <p className="fw-medium account-email-value">
                  {usersData.user_email}
                </p>
              </div>
            </div>
            {/* Image Side */}
            <div className="col-6 image-side">
              <div
                className="profile-pic ms-auto position-relative"
                style={{
                  background: `url(${
                    usersData.user_img ? usersData.user_img : ""
                  })`,
                }}
              >
                <div className="update-profile-pic d-flex justify-content-center align-items-center">
                  <i className="fa-solid fa-pen"></i>
                  <input
                    type="file"
                    name="user_img"
                    className="profile-pic-input"
                    onChange={userImgHandler}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Admin Profile Header End */}

        {/* Admin Profile Update Form Start */}
        <div className="container-fluid p-0 admin-panel-profile-update-form">
          <div className="row app-container signup-form-cover update-form-cover">
            <form
              method="post"
              className="p-0"
              onSubmit={(e) => {
                e.preventDefault();
              }}
            >
              {/* Row 1 */}
              <div className="d-flex gap-4 signup-form-row">
                <div className="col p-0 signup-col">
                  <label className="form-label">First Name</label>
                  <input
                    type="text"
                    name="user_first_name"
                    placeholder="First Name"
                    className="form-control text-capitalize"
                    required
                    value={usersData.user_first_name}
                    onChange={(e) => {
                      setUsersData({
                        ...usersData,
                        user_first_name: e.target.value.toLowerCase(),
                      });
                    }}
                  />
                </div>
                <div className="col p-0 signup-col">
                  <label className="form-label">Last Name</label>
                  <input
                    type="text"
                    name="user_last_name"
                    placeholder="Last Name"
                    className="form-control text-capitalize"
                    required
                    value={usersData.user_last_name}
                    onChange={(e) => {
                      setUsersData({
                        ...usersData,
                        user_last_name: e.target.value.toLowerCase(),
                      });
                    }}
                  />
                </div>
              </div>

              {/* Row 2 */}
              <div className="d-flex gap-4 signup-form-row">
                <div className="col p-0 signup-col">
                  <label className="form-label">Email</label>
                  <input
                    type="email"
                    name="user_email"
                    placeholder="Email"
                    className="form-control"
                    required
                    value={usersData.user_email}
                    onChange={(e) => {
                      setUsersData({
                        ...usersData,
                        user_email: e.target.value.toLowerCase(),
                      });
                    }}
                  />
                </div>
                <div className="col p-0 signup-col">
                  <label className="form-label">Password</label>
                  <input
                    type="password"
                    name="user_password"
                    placeholder="Password"
                    className="form-control"
                    ref={showHide}
                    required
                    value={usersData.user_password}
                    onChange={(e) => {
                      setUsersData({
                        ...usersData,
                        user_password: e.target.value.toLowerCase(),
                      });
                    }}
                    onFocus={showHandler}
                    onBlur={HideHandler}
                  />
                </div>
              </div>

              {/* Row 3 */}
              <div className="d-flex gap-4 signup-form-row">
                <div className="col p-0 signup-col">
                  <label className="form-label">Home Address</label>
                  <input
                    type="text"
                    name="user_home_address"
                    placeholder="Home Address"
                    className="form-control text-capitalize"
                    required
                    value={usersData.user_home_address}
                    onChange={(e) => {
                      setUsersData({
                        ...usersData,
                        user_home_address: e.target.value.toLowerCase(),
                      });
                    }}
                  />
                </div>
                <div className="col p-0 signup-col">
                  <label className="form-label">Mobile Number</label>
                  <input
                    type="text"
                    name="user_phone_number"
                    placeholder="Mobile Number"
                    className="form-control"
                    required
                    value={usersData.user_phone_number}
                    onChange={(e) => {
                      setUsersData({
                        ...usersData,
                        user_phone_number: e.target.value.toLowerCase(),
                      });
                    }}
                  />
                </div>
              </div>

              {/* Submit Btn */}
              <button
                type="submit"
                className="btn custom-btn signup-btn rounded-pill d-block mx-auto"
                onClick={updateUsersHandler}
              >
                Update Account
              </button>
            </form>
          </div>
        </div>
        {/* Admin Profile Update Form End */}
      </>
    );
}
